import './Checkbox.css';

function MultiCheckboxInput(props) {
    const selectedValues = Array.isArray(props.value) ? props.value : [];

    const toggleOption = (optionValue) => {
        const exists = selectedValues.includes(optionValue);
        const nextValues = exists
            ? selectedValues.filter(value => value !== optionValue)
            : [...selectedValues, optionValue];
        props.onChange?.(nextValues);
    };

    const renderContent = (option, checked) => {
        if (props.hasOwnProperty('contentRenderer')) {
            return props.contentRenderer(option, checked, () => toggleOption(option.value));
        } else {
            return (
                <>
                    {option.label}
                    <input checked={checked} onChange={() => toggleOption(option.value)}
                           type="checkbox" name={option.value} value={option.value}/>
                </>
            )
        }
    }

    return (
        <div className="MultiCheckboxInput">
            {props.label}
            <div className="choices">
                {props.options.map(option => {
                    return (<div key={`${Math.random() * 1000}_${option.value}`}>
                        <label className="choice-label">
                            {renderContent(option, selectedValues.indexOf(option.value) !== -1)}
                        </label>
                    </div>);
                })}
            </div>
        </div>
    );
}

export default MultiCheckboxInput;
